import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const PauseIcon = (props: IconProps) => (
  <Icon width="24px" height="28px" viewBox="0 0 24 28" {...props}>
    <path d="M0 28h8V0H0v28ZM16 0v28h8V0h-8Z" />
  </Icon>
);

export default memo(PauseIcon);
